<script lang="ts">
    import type { IconAnimated } from "@components/material/Icon.module"
    import Icon from "@components/material/Icon.svelte"
    import { clickEnter } from "@utils/directives/accessibility"
    import { twMerge } from "tailwind-merge"
    export let className = ""
    export { className as class }
    export let label: string
    export let float = false
    export let enabled = true
    export let icon: IconAnimated
    $: floatClassList = float ? "right-3 top-3 z-10" : ""
</script>

<div
    tabindex={0}
    aria-disabled={!enabled}
    role="button"
    on:click
    on:keydown={clickEnter}
    aria-label={label}
    class={twMerge(
        "h-8 w-8 absolute aria-disabled:pointer-events-none aria-disabled:opacity-15 right-2 top-2 flex items-center justify-center rounded-full",
        floatClassList,
        className,
    )}
>
    <Icon {icon} class="h-5 w-5" />
</div>
